import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import {
  TransactionProxyState,
  TransactionProxyStatus,
  TransactionType,
  UseMutationProps,
} from "@lib/types";
import { Button, Space } from "antd";
import { useIntl } from "react-intl";

type Props = {
  transaction?: TransactionType;
  transactionUpdateMutation: UseMutationProps<Partial<TransactionType>>;
};

export default function ApprovalActions({
  transaction,
  transactionUpdateMutation,
}: Props) {
  const { messages } = useIntl();

  const { mutate, isPending: isUpdating } = transactionUpdateMutation;

  const handleApprovePayment = async () => {
    mutate({
      id: transaction?.id,
      status: TransactionProxyStatus.Confirmed,
      state: TransactionProxyState.ApprovedByProvider,
    });
  };

  if (transaction?.state !== TransactionProxyState.PendingProviderApproval) {
    return null;
  }

  return (
    <StyledFlex style={{ justifyContent: "end" }}>
      <Space>
        <Button
          type="primary"
          onClick={handleApprovePayment}
          loading={isUpdating}
        >
          {messages["common.approve"] as string}
        </Button>
      </Space>
    </StyledFlex>
  );
}
